import { store } from '@/store';
import Vue from 'vue';
import VueI18n from 'vue-i18n';

import messagesDe from '@/lang/de';
import messagesEn from '@/lang/en';
import messagesEs from '@/lang/es';
import messagesFi from '@/lang/fi';
import messagesFr from '@/lang/fr';
import messagesIt from '@/lang/it';
import messagesJa from '@/lang/ja';
import messagesNbNO from '@/lang/nb-NO';
import messagesNl from '@/lang/nl';
import messagesNnNO from '@/lang/nn-NO';
import messagesPl from '@/lang/pl';
import messagesPtBR from '@/lang/pt-BR';
import messagesPtPT from '@/lang/pt-PT';
import messagesSr from '@/lang/sr';
import messagesSv from '@/lang/sv';
import messagesTr from '@/lang/tr';
import messagesUk from '@/lang/uk';
import untranslated from '@/lang/untranslated';

Vue.use(VueI18n);

function withUntranslated(messages) {
    const merged = { ...messages };

    Object.keys(untranslated).forEach((namespace) => {
        merged[namespace] = {
            ...messages[namespace],
            ...untranslated[namespace],
        };
    });

    return merged;
}

const i18n = new VueI18n({
    locale: store.getters.lang ?? 'en',
    fallbackLocale: 'en',
    messages: {
        de: withUntranslated(messagesDe),
        en: withUntranslated(messagesEn),
        es: withUntranslated(messagesEs),
        fi: withUntranslated(messagesFi),
        fr: withUntranslated(messagesFr),
        it: withUntranslated(messagesIt),
        ja: withUntranslated(messagesJa),
        'nb-NO': withUntranslated(messagesNbNO),
        nl: withUntranslated(messagesNl),
        'nn-NO': withUntranslated(messagesNnNO),
        pl: withUntranslated(messagesPl),
        'pt-BR': withUntranslated(messagesPtBR),
        'pt-PT': withUntranslated(messagesPtPT),
        sr: withUntranslated(messagesSr),
        sv: withUntranslated(messagesSv),
        tr: withUntranslated(messagesTr),
        uk: withUntranslated(messagesUk),
    },
});

document.documentElement.lang = i18n.locale;

export default i18n;
